module.exports = __webpack_public_path__ + "static/pt-sans-v12-latin-regular-7a9a412d3b5f0fcf44a43035ef5749eb.woff";